import React, { useState } from 'react';
import { ToggleButtonItem, ToggleButton, Panel, PanelTheme } from '@apply/components';

export const ToggleButtonDemo: React.FC<{}> = ({}) => {
    const [moneySelected, set_moneySelected] = useState<string[]>(['dollar']);
    const [yesNoSelected, set_yesNoSelected] = useState<string[]>(['Yes']);
    const [moneySelectedWithBubble, set_moneyWithBubbleSelected] = useState<string[]>(['dollar']);
    const [yesNoSelectedWithBubble, set_yesNoWithBubbleSelected] = useState<string[]>(['Yes']);

    const yesNoButtonItems: ToggleButtonItem[] = [
        {
            id: 'Yes',
            text: 'Yes',
            hint: 'Click Yes',
        },
        {
            id: 'No',
            text: 'No',
            hint: 'Click No',
        },
    ];

    const dollarPercentButtonItems: ToggleButtonItem[] = [
        {
            id: 'dollar',
            text: '$',
            hint: 'Click $',
        },
        {
            id: 'percent',
            text: '%',
            hint: 'Click %',
        },
    ];

    const onMoneyItemsChange = (item: string) => {
        set_moneySelected([item]);
    };

    const onYesItemsChange = (item: string) => {
        set_yesNoSelected([item]);
    };

    const onMoneyItemsChangeWithBubble = (item: string) => {
        set_moneyWithBubbleSelected([item]);
    };

    const onYesItemsChangewithBubble = (item: string) => {
        set_yesNoWithBubbleSelected([item]);
    };

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Toggle Button :</h2>
            <br />
            <Panel
                theme={PanelTheme.White}
                width='400px'
            >
                <ToggleButton
                    id='toggleButtonDemoYesNo'
                    items={yesNoButtonItems}
                    selectedItems={yesNoSelected}
                    stylingMode='outlined'
                    selectionMode='single'
                    onItemClick={(e) => onYesItemsChange(e?.itemData.id)}
                    width='250px'
                />
                <br />
                <br />
                <ToggleButton
                    id='toggleButtonDemoPercentDollar'
                    items={dollarPercentButtonItems}
                    selectedItems={moneySelected}
                    stylingMode='outlined'
                    selectionMode='single'
                    onItemClick={(e) => onMoneyItemsChange(e?.itemData.id)}
                    width='250px'
                />
                <br />
                <br />
                <ToggleButton
                    id='toggleButtonDemoYesNo'
                    items={yesNoButtonItems}
                    selectedItems={yesNoSelectedWithBubble}
                    stylingMode='outlined'
                    selectionMode='single'
                    onItemClick={(e) => onYesItemsChangewithBubble(e?.itemData.id)}
                    width='250px'
                    label='Yes / No Toggle with label'
                    showInfoIcon={true}
                    infoText='Yes / No Toggle with label'
                />
                <br />
                <br />
                <ToggleButton
                    id='toggleButtonDemoPercentDollar'
                    items={dollarPercentButtonItems}
                    selectedItems={moneySelectedWithBubble}
                    stylingMode='outlined'
                    selectionMode='single'
                    onItemClick={(e) => onMoneyItemsChangeWithBubble(e?.itemData.id)}
                    width='250px'
                    label='Toggle with label'
                    showInfoIcon={true}
                    infoText='Yes / No Toggle with label'
                />
            </Panel>
        </div>
    );
};
